import axiosInstance from 'src/utils/axios';
import {
  ImpactByMerchantQuery,
  ImpactByTransactionQuery,
  ImpactFlightsResponse,
  ImpactQuery,
  ImpactResponse,
} from './types.api';

//
//

const BASE_URL = 'impacts/v1';

//

export const getImpactAPI = async (params: ImpactQuery, options?: any): Promise<ImpactResponse> => {
  const response = await axiosInstance.get<ImpactResponse>(`${BASE_URL}/projects`, {
    params: params,
  });

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getImpactAllAPI = async (locale: string): Promise<ImpactResponse> => {
  const response = await axiosInstance.get<ImpactResponse>(`${BASE_URL}/all?locale=${locale}`);

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getImpactFlightsAPI = async (locale: string): Promise<ImpactFlightsResponse> => {
  const response = await axiosInstance.get<ImpactFlightsResponse>(
    `${BASE_URL}/flights?locale=${locale}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getImpactMerchantAPI = async (
  query: ImpactByMerchantQuery
): Promise<ImpactResponse> => {
  const { merchant, locale } = query;

  const response = await axiosInstance.get<ImpactResponse>(
    `${BASE_URL}/merchants/${merchant}?locale=${locale}&fields=flightsImpact`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getImpactTransactionAPI = async (
  query: ImpactByTransactionQuery
): Promise<ImpactResponse> => {
  const { transactionId, locale } = query;

  const localeParam = locale ? `&locale=${locale}` : '';

  const response = await axiosInstance.get<ImpactResponse>(
    `${BASE_URL}/purchases?purchaseId=${transactionId}${localeParam}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
